import { Box } from '@mui/material';

import { Lock01Icon } from '@/components/icons/Lock01Icon';
import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';
import { COLORS } from '@/styles/tokens/colors';

export const PRIVATE_HOUSEHOLD_TOOLTIP =
  'This household has been marked as private. You have access because you’ve been assigned to the household. To adjust this, reach out to Luminary support.';

interface PrivateHouseholdIndicatorProps {
  focusable?: boolean;
}

export function PrivateHouseholdIndicator({
  focusable = true,
}: PrivateHouseholdIndicatorProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      height={16}
      sx={{ '& > span': { display: 'flex' } }}
    >
      <Tooltip
        title={PRIVATE_HOUSEHOLD_TOOLTIP}
        placement="top"
        tabIndex={focusable ? 0 : -1}
        describeChild
      >
        <Lock01Icon
          size={16}
          color={COLORS.TEXT.SECONDARY}
          aria-label={focusable ? 'Private household' : undefined}
          aria-hidden={!focusable}
        />
      </Tooltip>
    </Box>
  );
}
